<template>
  <div class="relative rounded-md bg-custom-purple-500 p-4 top-2 shadow-lg">
    <div class="absolute top-1 right-1">
      <XIcon class="h-5 w-5 text-custom-purple-500 ring-1 ring-white bg-white rounded-sm cursor-pointer hover:bg-custom-purple-500 hover:text-white" 
        v-on:click="$emit('close')" aria-hidden="true" />
    </div>
    <div class="flex">
      <div class="flex-shrink-0">
        <div v-if="variant === 'success'"><CheckIcon class="h-6 w-6 text-white" /></div>
        <div v-if="variant === 'info'" class=" text-2xl text-white font-bold">!</div>
      </div>
      <div class="ml-4 flex items-center">
        <h3 class="text-sm text-left font-medium text-white">
          {{ info.message }}
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import { CheckIcon, XIcon } from "@heroicons/vue/solid";

export default {
  props: {
    info: {
      type: Object,
      required: true,
    },
    variant: {
      type: String,
      default: "success", // can be 'info', 'success', 'warning', 'error'
    },
  },
  emits: ["close"],
  components: {
    CheckIcon,
    XIcon,
  },
};
</script>
